import { animate, inView } from "motion";

document.addEventListener('DOMContentLoaded', () => {
    // Select all the block-package elements
    const blockPackage = document.querySelectorAll('.block-package');

    // Check if there are no block-package elements
    if (blockPackage.length === 0) return;

    // Loop through each block-package element
    blockPackage.forEach((block) => {
        // Select the fade-in, fade-up, fade-down, fade-left, fade-right elements inside each block-package
        const fadeAnimations = block.querySelectorAll('.fade-in, .fade-up, .fade-down, .fade-left, .fade-right');

        fadeAnimations.forEach((element) => {
            let transformValue = '';

            // Determine the correct transform value based on the class
            if (element.classList.contains('fade-up')) {
                transformValue = 'translateY(60px)';
            } else if (element.classList.contains('fade-down')) {
                transformValue = 'translateY(-60px)';
            } else if (element.classList.contains('fade-left')) {
                transformValue = 'translateX(60px)';
            } else if (element.classList.contains('fade-right')) {
                transformValue = 'translateX(-60px)';
            }

            // Trigger the animation when the element is in view
            inView(element, () => {
                // Start the animation when element is in view
                animate(element, 
                    { 
                        opacity: [0, 1], 
                        transform: [transformValue || 'translateY(0)', 'translateY(0)'],  // Ensure a valid transform
                    },
                    { 
                        duration: 0.6, 
                        delay: 0.125, 
                    }
                );
            });
        });
    });
});